import React from 'react';

class NoData extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let text = "";
    let indentClass = "styled-indent-blue";
    switch(this.props.service) {
      case "seo":
        indentClass = "styled-indent-green";
        text = "No SEO Data";
        break;
      case "overall":
        text = "No PPC Data.";
        break;
      case "search":
        text = "No paid search data.";
        break;
      case "social":
        text = "No paid social data.";
        break;
      case "display":
        text = "No display ads data.";
        break;
      case "video":
        text = "No video ads data.";
        break;
    }
    return (
      <div className={"row service-disabled " + indentClass}>
        <div className="col-12 pt-1 pl-3">
          <div className="no-gutters clear-both off-color-bg show py-4 px-5">
            <div className="standard-color-bg text-center py-4 px-1">
              <h5>{text}</h5>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default NoData;
